import { PageContent } from "components/PageContent";
import { useEffect, useState } from "react";
import { ISectionMenuItem } from "components/PageTopNav";
import PageTopNavV2 from "components/PageTopNavV2";
import { useEliteDealsAccess } from "./hooks/useEliteDealsAccess";
import { PrivateRoute } from "routes/PrivateRoute";
import { DealsBoxes } from "./DealsBoxes";
import FeaturedDeals from "pages/StoreFront/lib/FeaturedDeals";
import { LimitedDealsSection } from "pages/StoreFront/lib/LimitedDealsSection";

const EliteDeals = () => {
	const [sectionMenuData] = useState<ISectionMenuItem[]>([]);
	const canAccessEliteDeals = useEliteDealsAccess();

	useEffect(() => {
		window?.scrollTo(0, 0);
	}, []);

	return (
		<PrivateRoute isEnabled={canAccessEliteDeals}>
			<PageTopNavV2 sectionMenuData={sectionMenuData} />
			<PageContent source="elite_deals_page">
				<FeaturedDeals from="elite" />
				<LimitedDealsSection from="elite" />
				<DealsBoxes />
			</PageContent>
		</PrivateRoute>
	);
};

export default EliteDeals;
